<div class="TopBarcontainer">
  <mat-toolbar class="topbarNav">
    <div class="table-container">
      <div class="button-box">
        <mat-icon class="material-icons" (click)="showCategories = true"
          >menu</mat-icon
        >
      </div>
    </div>
    <!--mat-form-field class="search-field">

		  	<input matInput type="text" [(ngModel)]="value">
		  	<button mat-button  matSuffix mat-icon-button aria-label="Clear" >
		   		<mat-icon *ngIf="!value; else elseBlock">search</mat-icon>
		   		<mat-icon #elseBlock>close</mat-icon>
		  	</button>
		</mat-form-field-->

    <div class="title">
      <a href="/" style="text-decoration: none; color: #000;">CAPTAIN PUB</a>
    </div>
    <div class="table-container">
      <div class="table" [style.display]="id ? 'block' : 'none'">
        Table {{ id }}
      </div>
    </div>

<!--    <div class="covid-container" [class.opened]="showCategories">-->
<!--      <div class="covid" (click)="openDialog()" style="cursor: pointer;">-->
<!--        COVID-19-->
<!--      </div>-->
<!--    </div>-->
  </mat-toolbar>

  <div *ngIf="showCategories" class="selectCategories">
    <div class="absolute">
      <button mat-mini-fab class="close">
        <mat-icon class="material-icons" (click)="showCategories = false"
          >close</mat-icon
        >
      </button>
    </div>

    <div class="list">
      <div
        class="listitem"
        (click)="changeCategories('default')"
        [ngClass]="{ active: cat === 'default' }"
      >
        RESTAURATION
      </div>
      <div
        class="listitem"
        (click)="changeCategories('softs')"
        [ngClass]="{ active: cat === 'softs' }"
      >
        Softs
      </div>
      <div
        class="listitem"
        (click)="changeCategories('bieres')"
        [ngClass]="{ active: cat === 'bieres' }"
      >
        Bières
      </div>
      <div
        class="listitem"
        (click)="changeCategories('aperitif')"
        [ngClass]="{ active: cat === 'aperitif' }"
      >
        Apéritifs
      </div>
      <div
        class="listitem"
        (click)="changeCategories('vins')"
        [ngClass]="{ active: cat === 'vins' }"
      >
        vins
      </div>
      <div
        class="listitem"
        (click)="changeCategories('digestif')"
        [ngClass]="{ active: cat === 'digestif' }"
      >
        Digestifs
      </div>
      <div
        class="listitem"
        (click)="changeCategories('specialites_chaudes')"
        [ngClass]="{ active: cat === 'specialites_chaudes' }"
      >
        Spécialités chaudes
      </div>
      <div
        class="listitem"
        (click)="changeCategories('cocktail')"
        [ngClass]="{ active: cat === 'cocktail' }"
      >
        Cocktails
      </div>
      <div
        class="listitem"
        (click)="changeCategories('whisky')"
        [ngClass]="{ active: cat === 'whisky' }"
      >
        Whiskies
      </div>
      <div
        class="listitem"
        (click)="changeCategories('rhums')"
        [ngClass]="{ active: cat === 'rhums' }"
      >
        Rhums
      </div>
    </div>
  </div>
</div>
